module.exports = __webpack_public_path__ + "images/6f87097bb4387697600a56d218965e0b.png";